import axios from "axios";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { BASEURL } from "../../../constants/const";

export function ApiFinance() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  const url = BASEURL + "finance/";
  return {

    //EXPENSE HEADS
    GetExpenseHeadsListFromFinanceSoftware: () =>
      authAxios.get(url + "GetExpenseHeadsListFromFinanceSoftware"),
    GetExpenseHeadsList: () => authAxios.get(url + "GetExpenseHeadsList"),
    GetFinanceExpenseHeadsList: () => authAxios.get(url + "GetFinanceExpenseHeadsList"),
    AddFinanceFrequentUsedExpenseHead: (record) =>
      authAxios.post(url + "AddFinanceFrequentUsedExpenseHead", record),
    UpdateFinanceExpenseHead: (record) =>
      authAxios.post(url + "UpdateFinanceExpenseHead/", record),
    DeleteExpenseHead: (id) => authAxios.delete(url + "DeleteExpenseHead/" + id),

    //INFAQ HEADS
    GetFinanceInfaqHeadsListFromFinanceSoftware: () =>
      authAxios.get(url + "GetFinanceInfaqHeadsListFromFinanceSoftware"),
    GetInfaqHeadsList: () => authAxios.get(url + "GetInfaqHeadsList"),
    GetFinanceInfaqHeadList: () =>
      authAxios.get(url + "GetFinanceInfaqHeadList"),
    AddFinanceInfaqHead: (record) =>
      authAxios.post(url + "AddFinanceInfaqHead", record),
    UpdateFinanceInfaqHead: (record) =>
      authAxios.post(url + "UpdateFinanceInfaqHead/", record),
    DeleteInfaqHead: (id) => authAxios.delete(url + "DeleteInfaqHead/" + id),


    //FINANCE CATEGORIES
    GetFinanceCategoriesList: () => authAxios.get(url + "GetFinanceCategories"),
    AddFinanceCategory: (record) =>
      authAxios.post(url + "AddFinanceCategory", record),
    UpdateFinanceCategory: (id, record) =>
      authAxios.put(url + "UpdateFinanceCategory/" + id, record),
    DeleteFinanceCategory: (id) =>
      authAxios.delete(url + "DeleteFinanceCategory/" + id),

    //FINANCE ACCOUNT CATEGORY TYPES
    GetFinanceAccountCategoryTypes: () =>
      authAxios.get(url + "GetFinanceAccountCategoryTypes"),
    AddFinanceAccountCategoryType: (record) =>
      authAxios.post(url + "AddFinanceAccountCategoryType", record),
    UpdateFinanceAccountCategoryType: (id, record) =>
      authAxios.put(url + "UpdateFinanceAccountCategoryType/" + id, record),
    DeleteFinanceAccountCategoryType: (id) =>
      authAxios.delete(url + "DeleteFinanceAccountCategoryType/" + id),
    
    //FINANCE ACCOUNT CATEGORY
    GetFinanceAccountCategories: () =>
      authAxios.get(url + "GetFinanceAccountCategories"),
    GetFinanceAccountCategoriesList: () =>
      authAxios.get(url + "GetFinanceAccountCategoriesList"),
    GetFinanceAccountCategoriesListByType: (type) =>
      authAxios.get(url + "GetFinanceAccountCategoriesListByType/" + type),
    AddFinanceAccountCategory: (record) =>
      authAxios.post(url + "AddFinanceAccountCategory", record),
    UpdateFinanceAccountCategory: (id, record) =>
      authAxios.put(url + "UpdateFinanceAccountCategory/" + id, record),
    UpdateFinanceAccountCategories : (id, record) =>
      authAxios.put(url + "UpdateFinanceAccountCategories/" + id, record),
    DeleteFinanceAccountCategory: (id) =>
      authAxios.delete(url + "DeleteFinanceAccountCategory/" + id),

    //FINANCE DIMENSIONS
    GetFinanceDimensionsListFromFinanceSoftware: () =>
      authAxios.get(url + "GetFinanceDimensionsListFromFinanceSoftware"),
    UpdateFinanceDimensions2 : (id, record) =>
      authAxios.put(url + "UpdateFinanceDimensions2/" + id, record),
    GetFinanceCategoryDimensionsById : (id) =>
      authAxios.get(url + "GetFinanceCategoryDimensionsById/" + id),

    //FINANCE ACCOUNTS
    UpdateFinanceAccounts : (id, record) =>
      authAxios.put(url + "UpdateFinanceAccounts/" + id, record),
    GetFinanceCategoryAccountsById : (id) =>
      authAxios.get(url + "GetFinanceCategoryAccountsById/" + id),
  };
}
